import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OfferService from "../../services/OffersService";
import { toast } from "react-toastify";

export const fetchOffers = createAsyncThunk(
  "offer/fetchOffers",
  async (data) => {
    try {
      const res = await OfferService.getOffers(data);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchOfferRedemptionData = createAsyncThunk(
  "offer/fetchOfferRedemptionData",
  async (offerId) => {
    try {
      const res = await OfferService.getOfferRedemptionData(offerId);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchCustomerSecondTimeOfferPending = createAsyncThunk(
  "offer/fetchCustomerSecondTimeOfferPending",
  async (merchantId) => {
    try {
      const res = await OfferService.getCustomerSecondTimeOfferPending(
        merchantId
      );
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const createOffer = createAsyncThunk(
  "offer/createOffer",
  async (data, thunkAPI) => {
    try {
      const res = await OfferService.addOffer(data);
      if (res.status == 1) {
        toast.success(res.message);
        return res;
      } else {
        toast.warning(res.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchOfferById = createAsyncThunk(
  "offer/fetchOfferById",
  async (id) => {
    try {
      const res = await OfferService.getOfferById(id);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateOffer = createAsyncThunk(
  "offer/updateOffer",
  async (data) => {
    try {
      const res = await OfferService.editOffer(data);
      if (res.status == 1) {
        toast.success(res.message);
        return res.data;
      } else {
        toast.warning(res.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);

export const removeOffer = createAsyncThunk("offer/removeOffer", async (id) => {
  try {
    const res = await OfferService.deleteOffer(id);
    return id;
  } catch (error) {
    console.log(error);
  }
});

const initialState = {
  loading: false,
  redemptionLoading:false,
  error: "",
  offers: [],
  offer: null,
  total_pages: 0,
  total_records: 0,
  customerSecondTimeOfferPending: [],
  offerRedemptionData: [],
};

const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //Get All OFFERS
    builder
      .addCase(fetchOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOffers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.offers = payload?.data || [];
        state.total_pages = payload?.total_pages;
        state.total_records = payload?.total_records;
      })
      .addCase(fetchOffers.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(fetchCustomerSecondTimeOfferPending.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchCustomerSecondTimeOfferPending.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.customerSecondTimeOfferPending = payload?.data || [];
        }
      )
      .addCase(fetchCustomerSecondTimeOfferPending.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(fetchOfferRedemptionData.pending, (state) => {
        state.redemptionLoading = true;
      })
      .addCase(fetchOfferRedemptionData.fulfilled, (state, { payload }) => {
        state.redemptionLoading = false;
        state.offerRedemptionData = payload?.data || [];
      })
      .addCase(fetchOfferRedemptionData.rejected, (state) => {
        state.redemptionLoading = false;
      });

    // ADD OFFER

    builder
      .addCase(createOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOffer.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.offer = payload;
      })
      .addCase(createOffer.rejected, (state) => {
        state.loading = false;
      });

    // GET BY ID OFFER

    builder
      .addCase(fetchOfferById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOfferById.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.offer = payload;
      })
      .addCase(fetchOfferById.rejected, (state) => {
        state.loading = false;
      });

    //EDIT OFFER

    builder
      .addCase(updateOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateOffer.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.offer = { ...state.offer, ...payload };
      })
      .addCase(updateOffer.rejected, (state) => {
        state.loading = false;
      });

    // DELETE OFFER

    builder
      .addCase(removeOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeOffer.fulfilled, (state, { payload }) => {
        const deleteOffers = [...state.offers].filter(
          (offer) => offer.id != payload.offer_id
        );
        return {
          ...state,
          loading: false,
          offers: deleteOffers,
        };
      })
      .addCase(removeOffer.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default offerSlice.reducer;
